import classNames from 'classnames'

import type { Props as CardProps } from './CourseCertificationCard'
import CourseCertificationCard from './CourseCertificationCard'
import style from './style.scss'

type Props = {
  cards: CardProps[]
  className?: string
}

function CourseCertificationModule(props: Props) {
  const { cards, className } = props
  const gridParity = cards.length % 2 === 0 ? 'Even' : 'Odd'
  const gridStyle =
    cards.length % 3 === 0
      ? `threeByGrid${gridParity}`
      : `twoByGrid${gridParity}`

  return (
    <div
      className={classNames(style.cardContainer, style[gridStyle], className)}
    >
      {cards.map((card) => (
        <CourseCertificationCard
          key={card.captionCard.captionTitle}
          className={style.certificationCards}
          {...card}
        />
      ))}
    </div>
  )
}

export default CourseCertificationModule
